var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useEffect, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import isEqual from "lodash/isEqual";
import { DEFAULT_REGISTRATION_AGENCIES } from "../utils/filterDefaults";
import { appendSelectionParams, sameSelection, selectionFromParams, toggleRequiredSelection, } from "../utils/requiredSelection";
var agenciesFromSearch = function (search) {
    return selectionFromParams(new URLSearchParams(search), "agencies", DEFAULT_REGISTRATION_AGENCIES);
};
export var useAgencyPrefixFilters = function () {
    var history = useHistory();
    var location = useLocation();
    var _a = useState(true), filterPaneIsVisible = _a[0], setFilterPaneIsVisible = _a[1];
    // Initialised from the URL in the first render: a filter patched in by an
    // effect afterwards would change the search and send it twice.
    var _b = useState(function () { return ({
        agencies: agenciesFromSearch(location.search),
    }); }), filters = _b[0], setFilters = _b[1];
    var updateUrlWithFilters = function (next) {
        var params = new URLSearchParams();
        appendSelectionParams(params, "agencies", next.agencies, DEFAULT_REGISTRATION_AGENCIES);
        history.push({ search: params.toString() });
    };
    // The URL push stays outside the state updater: StrictMode runs updaters
    // twice, which pushed the same URL twice (Back then needed two clicks).
    // The filters including toggles not rendered yet: two toggles before a
    // re-render must both count.
    var latestFiltersRef = useRef(filters);
    latestFiltersRef.current = filters;
    var handleAgencyChange = function (agency) {
        var current = latestFiltersRef.current;
        var toggled = toggleRequiredSelection(current.agencies, agency);
        if (toggled === current.agencies)
            return;
        // one order for one selection: unchecking and re-checking an option must
        // not turn into a search for the same agencies in another order
        var agencies = __spreadArray([], toggled, true).sort();
        var next = __assign(__assign({}, current), { agencies: agencies });
        latestFiltersRef.current = next;
        setFilters(next);
        updateUrlWithFilters(next);
    };
    useEffect(function () {
        var fromUrl = agenciesFromSearch(location.search);
        setFilters(function (prev) {
            return isEqual(prev.agencies, fromUrl) ? prev : { agencies: fromUrl };
        });
    }, [location.search]);
    var isAnyFilterActive = !sameSelection(filters.agencies, DEFAULT_REGISTRATION_AGENCIES);
    var toggleFilterPane = function () { return setFilterPaneIsVisible(function (v) { return !v; }); };
    var handleClearFilters = function () {
        setFilters({ agencies: DEFAULT_REGISTRATION_AGENCIES });
        history.push({ search: "" });
    };
    return {
        filters: filters,
        setFilters: setFilters,
        filterPaneIsVisible: filterPaneIsVisible,
        toggleFilterPane: toggleFilterPane,
        handleAgencyChange: handleAgencyChange,
        handleClearFilters: handleClearFilters,
        isAnyFilterActive: isAnyFilterActive,
    };
};
